import React from 'react';
import { theme } from '../../../styles/theme';

interface Activity {
  id: number;
  action: string;
  user?: string;
  service?: string;
  time: string;
  status: string;
}

interface ActivityFeedProps {
  activities: Activity[];
  darkMode: boolean;
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({ activities, darkMode }) => {
  return (
    <div className="rounded-xl" style={{
      backgroundColor: darkMode ? theme.colors.background.darkPaper : theme.colors.background.paper,
      boxShadow: theme.widget.boxShadow,
    }}>
      <div className="px-6 py-4" style={{
        borderBottom: `1px solid ${darkMode ? theme.colors.border.dark : 'rgba(228, 165, 128, 0.1)'}`,
      }}>
        <h2 className="text-lg font-semibold" style={{ 
          color: darkMode ? theme.colors.text.darkPrimary : theme.colors.text.primary 
        }}>
          Recent Activity
        </h2>
      </div>
      <div className="divide-y">
        {activities.map((activity) => (
          <div key={activity.id} className="px-6 py-4 flex items-center justify-between transition-colors hover:bg-black hover:bg-opacity-5">
            <div className="flex items-center space-x-4">
              <div className="w-2 h-2 rounded-full" style={{
                backgroundColor: activity.status === 'success' ? theme.colors.status.success : theme.colors.status.error
              }}></div>
              <div>
                <p className="font-medium" style={{ 
                  color: darkMode ? theme.colors.text.darkPrimary : theme.colors.text.primary 
                }}>
                  {activity.action}
                </p>
                <p className="text-sm" style={{ 
                  color: theme.colors.text.secondary 
                }}>
                  {activity.user || activity.service}
                </p>
              </div>
            </div>
            <span className="text-sm" style={{ 
              color: theme.colors.text.secondary 
            }}>
              {activity.time}
            </span>
          </div>
        ))}
      </div>
      <div className="px-6 py-3" style={{
        borderTop: `1px solid ${darkMode ? theme.colors.border.dark : 'rgba(228, 165, 128, 0.1)'}`,
      }}>
        <button className="text-sm font-medium transition-colors hover:opacity-80" style={{ 
          color: theme.colors.secondary.main 
        }}>
          View all activity →
        </button>
      </div>
    </div>
  );
};

export default ActivityFeed;